import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
});

export default api;

export const loginUser = (email, password) => {
    return api.post('/api/login', { email, password });
  };
  
  export const sendPrescription = (formData) => {
    return api.post('/api/send-prescription', formData);
  };
  
  export const sendAppointment = (formData) => {
    return api.post('/api/send-appointment', formData);
  };